module.exports = __webpack_public_path__ + "static/img/3x_gif_icon.7314492.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/3x_gif_icon.png
// module id = 644
// module chunks = 2